/// <reference path="../../typings.d.ts" />
import { validateToken } from '../services/account.service';
import { Router, ActivatedRoute } from '@angular/router';
import { OnInit, Component } from '@angular/core';
import { IdPUserRole } from '../models/idpuser_role';
import { Alert } from '../shared/alert';
import { IdentityService } from '../services/identity.service';
import { AppTitle } from '../shared/title';
import { FindIdPUserRole } from '../models/find_idpuser_role';
import { isDateSet, dateFormat } from '../shared/date_helper';
import { Subscription } from 'rxjs';

@Component({
	selector: 'users',
	styles: [`
		.tag {
			margin-right:2px;
			background-color:#e0e0e0;
			border-radius:4px;
			padding:5px;
		}
    `],
	template: `
        <div class="row" [hidden]="msgHead.msg == ''">
            <div class="col-lg-8 col-md-6 col-xs-12">
                <alert [alert]="msgHead"></alert>
            </div>
        </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-6 col-md-6 col-xs-12">
                <alert [alert]="msg" style="display:block;"></alert>
            </div>
        </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-8 col-md-7 col-xs-12">
                <button type="button" class="btn btn-large btn-primary" (click)="addRole()">Add New</button>
				<button type="button" class="btn btn-large btn-deny" style="margin-left:5px;" (click)="refresh()">Refresh</button>
				<a style="margin-left:10px;cursor: pointer;" (click)="goBack()">Go Back</a>
				</div>
		    <div class="col-lg-8 col-md-12 col-xs-12">
                <div class="card">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Organization</th>
                                <th>Service</th>
                                <th>Roles</th>
										  <th>Updated At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of data; let i = index">
                                <td style="width:15%;">{{ row.organizationName }}</td>
                                <td style="width:15%;">{{ row.serviceId }}</td>
										  <td style="width:12%;">
            								<span class="tag" *ngFor="let role of row.roles.split(','); let j = index" style="padding: 2px 4px; display: inline-block; margin-bottom: 3px; margin-right: 3px;">{{role}}</span>
            						  </td>
                                <td style="width:15%;">{{ printDate(row.updatedAt) }}</td>
                                <td style="width:25%;">
                                    <span title="Edit" class="btn-link" style="cursor: pointer;" (click)="edit(row)">Edit</span> |
                                    <span title="Remove Role" class="glyphicon glyphicon-trash" aria-hidden="true" (click)="removeRow(row)" style="cursor:pointer;"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
		  </div>
    `
})

export class IdPUserRolesListComponent implements OnInit {
	private subscriptionQueryParams: Subscription;
	data: IdPUserRole[];
	fobj: FindIdPUserRole;
	msg: Alert;
	msgHead: Alert;
	acctNumber: string;
	hasAccess: boolean;
	userId: string;
	titleStr: string;
	idpId: string;
	username:string;
	idpName:string;

	constructor(private router: Router, private idsvc: IdentityService, private title: AppTitle, private activatedRoute: ActivatedRoute){
		this.hasAccess = true;
		this.msg = new Alert();
		this.msgHead = new Alert();
		this.titleStr = '';
		title.setTitles({
			title: 'Roles - IdP User',
			dashboard: 'Roles - IdP User'
		});

		this.fobj = new FindIdPUserRole();
		this.data = [];

		this.subscriptionQueryParams = activatedRoute.queryParams.subscribe(
			(params) => {
				this.username = decodeURIComponent(params['username'])
				this.idpName = decodeURIComponent(params['idpName'])
			}
		);
		this.titleStr = this.username + ' / Roles'

	}

	ngOnInit(){
		this.acctNumber = this.activatedRoute.snapshot.params['acctnumber'];
		this.userId = this.activatedRoute.snapshot.params['userId'];
		this.idpId = this.activatedRoute.snapshot.params['idpid'];
		if (this.acctNumber != null) {
			this.idsvc.validateAcctNumber(this.acctNumber)
				.subscribe(res => {
					if (!res) {
						this.msgHead.error(`You don't have access to this district number ${this.acctNumber}`);
						this.hasAccess = false;
					}
				}, err => {
					console.log(err);
					let e = this.idsvc.getUserErrorDefault(err);
					this.msgHead.error(e);
					this.hasAccess = false;
				})
		}
		this.loadData();
		this.title.setBreadcrumbs([
			{ title: 'IdP Users ', link: `idp/${this.acctNumber}/idp-users/users` },
			{ title: this.idpName + ' ', link: '' },
			{ title: this.titleStr, link: '' },
		]);
	}

	loadData(){
		this.data = [];
		this.fobj.idpId = parseInt(this.idpId);
		this.fobj.userId = this.userId;
		this.idsvc.findIdPUserRoleApi(this.acctNumber, this.fobj).subscribe((rows: IdPUserRole[]) => {
			for (let e of rows) {
				if(e.serviceId === 'school-manager'){
					e.serviceId = 'School Manager'
				}else if(e.serviceId === 'district-manager') {
					e.serviceId = 'District Manager'
				}else if(e.serviceId === 'identity') {
					e.serviceId = 'Identity'
				}
				this.data.push(e);
			}
		}, err => {
			console.log(err);
			if (this.idsvc.isErrNotFound(err)) {
				this.msg.warning(this.idsvc.getUserError(err));
			} else {
				if (this.idsvc.isErrUnauthorized(err)) {
					this.hasAccess = false;
					this.msg.error(this.idsvc.getUserErrorDefault(err));
				} else {
					this.msg.error(this.idsvc.getUserErrorDefault(err));
				}
			}
		});
	}

	refresh() {
		if (!validateToken()) {
			this.router.navigate(['/login']);
			return;
		}
		this.loadData();
		this.msg.close();
	}

	printDate(d: Date): string {
		let df = '01/02/2006 03:04 PM';
		if (isDateSet(d)) {
			return dateFormat(d, df);
		}
		return '';
	}

	addRole() {
		var params: any = {};
		params['username'] = this.username;
		params['idpName'] = this.idpName;
		this.router.navigate([`idp/${this.acctNumber}/idp-users/${this.idpId}/users/${this.userId}/roles/add`],{ queryParams: this.idsvc.params(params) });
		return;
	}

	edit(ids: IdPUserRole){
		var params: any = {};
		params['username'] = this.username;
		params['idpName'] = this.idpName;
		this.router.navigate([`idp/${this.acctNumber}/idp-users/${this.idpId}/users/${this.userId}/roles/${ids.id}/edit`], { queryParams: this.idsvc.params(params) });
		return;
	}

	removeRow(ids: IdPUserRole){
		if (!validateToken()) {
			this.router.navigate(['/login']);
			return;
		}
		this.idsvc.removeIdPUserRoleApi(this.acctNumber, ids.id)
			.subscribe(res => {
				this.data.splice(this.data.indexOf(ids), 1);
			}, err => {
				console.log(err);
				let e = this.idsvc.getUserErrorDefault(err);
				this.msgHead.error(e);
			});
	}

	ngOnDestroy() {
		this.subscriptionQueryParams.unsubscribe();
	}

	goBack() {
		this.router.navigate([`idp/${this.acctNumber}/idp-users/users`]);
		return;
	}

}
